import React from 'react'
import PropTypes from 'prop-types'

import { SvgIcon, Checkbox } from '../'


export const TableHeaderRow = ({ data, querySortableColumns, orderBy, cellWrap, changeSort, firstColumnWidth, sortedColumnIndex, sortedDirection, onColumnClick, onGlobalSelect, allRowsSelected, fixedHeader }) => {
  const style = fixedHeader
    ? {
        position: 'sticky',
        top: 0,
        zIndex: 2
      }
    : {}

  let headers = data.map((columnHeader, index) => {
    let sortableColumn = querySortableColumns
      ? querySortableColumns[columnHeader]
      : null
    let sortDirection = sortedDirection !== null && sortedColumnIndex === index
      ? sortedDirection
      : sortableColumn && orderBy && orderBy.includes(sortableColumn.orderByName)
        ? orderBy.includes('-')
          ? 'descending'
          : 'ascending'
        : null
    let sortAppliedOnColumn = sortableColumn && sortDirection !== null
    let sortedColumn = (sortableColumn && sortAppliedOnColumn) || sortedColumnIndex === index
    let sortState = sortedDirection !== null && sortedColumnIndex === index
      ? `slds-is-sorted ${sortDirection === 'ascending' ? 'slds-is-sorted_asc' : 'slds-is-sorted_desc'}`
      : querySortableColumns
        ? sortedColumn
          ? `slds-is-sorted ${sortDirection === 'ascending'
            ? 'slds-is-sorted_asc' : 'slds-is-sorted_desc'}`
          : 'slds-is-sortable'
        : ''

    return (
      <th
        className={`slds-theme_shade ${sortState} ${sortedColumn ? 'sorted-column' : sortableColumn ? 'sortable-column' : ''} ${onColumnClick ? 'clickable': ''}`}
        aria-sort={sortableColumn || sortedColumnIndex === index
          ? sortDirection
          : ''
        }
        scope='col'
        style={firstColumnWidth && index === 0
          ? {...style, width: firstColumnWidth }
          : style
        }
        key={`table_header_${columnHeader}`}
        onClick={onColumnClick
          ? () => onColumnClick(index)
          : null
        }>
        <div
          title={columnHeader}
          className={cellWrap ? 'slds-cell-wrap' : 'slds-truncate'}
          style={cellWrap ? { overflowWrap: 'unset', wordWrap: 'unset' } : null}>
          {sortableColumn
            ? <a
                className='slds-th__action slds-text-link_reset'
                onClick={() => {
                  let orderByNameToSortOn = null
                  if (sortableColumn.orderByName !== orderBy) {
                    orderByNameToSortOn = sortableColumn.orderByName
                  } else {
                    orderByNameToSortOn = `-${sortableColumn.orderByName}`
                  }
                  if (changeSort) {
                    changeSort(orderByNameToSortOn)
                  }
                }}
                role='button'
                tabIndex='0'>
                {columnHeader}
                {(sortableColumn || sortedColumnIndex === index) &&
                  <div className='slds-size_1-of-1 slds-text-align_right'>
                    <SvgIcon
                      variant='utility'
                      symbol={sortedColumn || sortedColumnIndex === index
                        ? sortDirection === 'descending'
                          ? 'up'
                          : 'down'
                        : ''
                      }
                      size='xx-small'
                      colour={sortedColumn || sortedColumnIndex === index
                        ? 'success'
                        : 'inherit'}
                      title={sortDirection && `${sortDirection} sort`}
                    />
                  </div>
                }
              </a>
            : sortedDirection
              ? <a
                  className='slds-th__action'
                  role='button'
                  tabIndex='0'
                  style={{ color: 'inherit', textDecoration: 'none', paddingTop: 0, height: 'inherit' }}>
                  {columnHeader}
                  <div className='slds-size_1-of-1 slds-text-align_right slds-align_absolute-center'>
                    <SvgIcon
                      variant='utility'
                      symbol={sortedColumnIndex === index
                        ? sortDirection === 'ascending'
                          ? 'up'
                          : 'down'
                        : ''
                      }
                      size='xx-small'
                      colour='success'
                      title={sortDirection && `${sortDirection} sort`}
                    />
                   </div>
                </a>
              : <span style={{ cursor: 'default' }}>
                  {columnHeader}
                </span>
          }
        </div>
      </th>
    )
  })

  return (
    <tr className='slds-text-heading_label'>
      {onGlobalSelect &&
        <th className='slds-theme_shade' style={{ ...style, width: '50px' }}>
          <Checkbox
            id='globalSelect'
            onChange={onGlobalSelect}
            checked={allRowsSelected}
          />
        </th>
      }
      {headers}
    </tr>
  )
}

TableHeaderRow.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string).isRequired,
  querySortableColumns: PropTypes.object,
  orderBy: PropTypes.string,
  changeSort: PropTypes.func,
  onGlobalSelect: PropTypes.func,
  allRowsSelected: PropTypes.bool,
  cellWrap: PropTypes.bool,
  fixedHeader: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/table/TableHeaderRow.js